import React, { useState } from 'react';
import axios from 'axios';

const AddEmployee = () => {
  const [employee, setEmployee] = useState({
    // name: '',
    userId: '',
    password: ''
  });

  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setEmployee({ ...employee, [e.target.name]: e.target.value });
  };

  const handleAddEmployee = async (e) => {
    e.preventDefault();

    if ( !employee.userId || !employee.password) {
      setError('All fields are required');
      return;
    }

    try {
      const response = await axios.post('https://api.happychd.com/api/employees', employee);
      setMessage(response.data.message);
      setError('');
      setEmployee({  userId: '', password: '' });
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add employee');
      setMessage('');
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white shadow rounded mt-10">
      <h2 className="text-2xl font-semibold mb-6">Add Employee</h2>

      {message && (
        <div className="bg-green-100 text-green-700 px-4 py-2 rounded mb-4">
          ✅ {message}
        </div>
      )}

      {error && (
        <div className="bg-red-100 text-red-700 px-4 py-2 rounded mb-4">
          ❌ {error}
        </div>
      )}

      <form onSubmit={handleAddEmployee} className="space-y-4">
        {/* <div>
          <label className="block mb-1 font-medium">Name</label>
          <input
            type="text"
            name="name"
            value={employee.name}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Enter full name"
          />
        </div> */}

        <div>
          <label className="block mb-1 font-medium">User ID</label>
          <input
            type="text"
            name="userId"
            value={employee.userId}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Unique ID"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Password</label>
          <input
            type="password"
            name="password"
            value={employee.password}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Enter password"
          />
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-5 py-2 rounded hover:bg-blue-700"
        >
          Add Employee
        </button>
      </form>
    </div>
  );
};

export default AddEmployee;
